import gql from 'graphql-tag';
const TRIGGER_AIRFLOW_DAG = gql`
  query triggerAirflowDAG($where: JSON) {
    triggerAirflowDAG(where: $where)
  }
`;

export default TRIGGER_AIRFLOW_DAG;
